import React from 'react';
import PropTypes from 'prop-types';

/**
 * TestTube:
 *  - Component that renders a single TestTube entity
 */
export function TestTube({children}) {
  return <div className='option'>{children}</div>;
}

TestTube.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
